import React from 'react'
import PropTypes from 'prop-types'

const AssessmentInfo = props => {
  return (
    <div className="d-flex justify-content-between">
      <h6>ID: {props.id}</h6>
      <h6>Due Date: {props.dueAt}</h6>
      <h6>Points: {props.pointsPossible}</h6>
      <h6>Unlock: {props.unlockAt}</h6>
      <h6>Lock: {props.lockAt}</h6>
      <h6>Created: {props.createdAt}</h6>
      <h6>Published: {props.published ? 'True' : 'False'}</h6>
      <h6>Submission Types: {props.subTypes}</h6>
    </div>
  )
}

export default AssessmentInfo

AssessmentInfo.propTypes = {
  id: PropTypes.number,
  dueAt: PropTypes.string,
  pointsPossible: PropTypes.number,
  unlockAt: PropTypes.string,
  lockAt: PropTypes.string,
  createdAt: PropTypes.string,
  published: PropTypes.bool,
  subTypes: PropTypes.array,
}
